export default __webpack_public_path__ + "static/wtcr-tyre-pattern-75c4469d0d08d2f9a134bcbc2ef124b7.svg";